import { fetchWithRetry } from 'shared/api/fetch-with-retry';
import { env } from 'shared/config';
import { UserData } from './types';

const OFFER_URL = `${env.API_URL}/api/v1/offer`;

export const getOfferData = async (token: string, id: string) => {
  const data = await fetchWithRetry<UserData>(`${OFFER_URL}/${id}/`, {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  });

  return data;
};

type SendOfferDecisionParams = {
  status: string;
  startWorkDate?: string;
  token: string;
  id: string;
};

export const sendOfferDecision = async ({ status, startWorkDate, token, id }: SendOfferDecisionParams) => {
  const data = await fetchWithRetry(`${OFFER_URL}/${id}/decision_making/`, {
    method: 'PATCH',
    headers: {
      Authorization: token,
    },
    body: JSON.stringify({
      status: status,
      ...(startWorkDate ? { startWorkDate: startWorkDate } : {}),
    }),
  });

  return data;
};
